import { Component, Vue } from "vue-property-decorator";
import Utils from "@/vue/infrastructure/utils/helpers";

@Component({
  components: {
    DfSectionDigitalPublication: () => Utils.externalComponent2("df-section-digital-publication"),
  },
})
export default class DfPagePdfComponent extends Vue {
  private gamAdvSelexRefreshTimeout: any = null;

  get gamAdvSelexEnabled(): boolean {
    return Utils.gamAdvSelexEnabled();
  }

  get gamAdvSelexEnvironment(): string {
    return Utils.gamAdvSelexEnvironment();
  }

  get gamAdvSelexBrand(): string {
    return Utils.gamAdvSelexBrand();
  }

  mounted() {
    if (this.gamAdvSelexEnabled) {
      const eventUpdate = new Event("updateDOMContent");
      document.dispatchEvent(eventUpdate);
      clearTimeout(this.gamAdvSelexRefreshTimeout);
      const eventRefresh = new Event("refreshDOMContent");
      this.gamAdvSelexRefreshTimeout = setTimeout(() => { document.dispatchEvent(eventRefresh) }, 500);
    }
  }

  updated() {
    if (this.gamAdvSelexEnabled) {
      const eventUpdate = new Event("updateDOMContent");
      document.dispatchEvent(eventUpdate);
      clearTimeout(this.gamAdvSelexRefreshTimeout);
      const eventRefresh = new Event("refreshDOMContent");
      this.gamAdvSelexRefreshTimeout = setTimeout(() => { document.dispatchEvent(eventRefresh) }, 500);
    }
  }
}
